import { IS_IN_D9_APP } from './constants';

window.d9d = {
  exec(cmd, option, callback, fail) {
    window.d9ok = callback;
    window.d9fail = fail;
    if (IS_IN_D9_APP) {
      const url = new URL('d9d://' + cmd + '/' + JSON.stringify(option));
      window.open(url.toString(), "_self");
    } else {
      fail({ success: false, message: 'Not in D9 app' });
    }
  },
};
